import PageBuilderBlock from '../pageBuilderBlock/PageBuilderBlock';

export default {

  name: 'page-builder-row',

  props: {
    row: {}
  }
};



// WEBPACK FOOTER //
// ./src/apps/booking/components/pageBuilder/pageBuilderRow/PageBuilderRow.js